import PropTypes from 'prop-types';
// material
import { Card, Grid, Stack, TextField, Typography, Autocomplete } from '@material-ui/core';
// routes
import ChangePassword from './ChangePassword';

// ----------------------------------------------------------------------
MyProfile.propTypes = {
  currentUser: PropTypes.object,
  USER_ROLE_LIST: PropTypes.array
};

export default function MyProfile({ currentUser, USER_ROLE_LIST }) {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Card sx={{ p: 3 }}>
          <Stack spacing={3}>
            <Stack sx={{ mb: 2 }} direction="row" spacing={{ xs: 3, sm: 2 }}>
              <Typography variant="h5" color="primary">
                General Information
              </Typography>
            </Stack>
            <Stack direction="row" spacing={{ xs: 3, sm: 2 }}>
              <Stack direction="column" sx={{ width: '100%' }} spacing={{ xs: 3, sm: 2 }}>
                <Typography variant="subtitle1">First name</Typography>
                <TextField value={currentUser?.first_name || ''} disabled fullWidth label="" />
              </Stack>

              <Stack direction="column" sx={{ width: '100%' }} spacing={{ xs: 3, sm: 2 }}>
                <Typography variant="subtitle1">Last name</Typography>
                <TextField value={currentUser?.last_name || ''} disabled fullWidth label="" />
              </Stack>
            </Stack>

            <Stack direction="row" spacing={{ xs: 3, sm: 2 }}>
              <Stack direction="column" sx={{ width: '100%' }} spacing={{ xs: 3, sm: 2 }}>
                <Typography variant="subtitle1">Email</Typography>
                <TextField value={currentUser?.email || ''} disabled fullWidth label="" />
              </Stack>

              <Stack direction="column" sx={{ width: '100%' }} spacing={{ xs: 3, sm: 2 }}>
                <Typography variant="subtitle1">Contact Number</Typography>
                <TextField value={currentUser?.phone || ''} disabled fullWidth label="" />
              </Stack>
            </Stack>

            <Stack sx={{ width: '50%' }} direction="column" spacing={{ xs: 3, sm: 2 }}>
              <Typography variant="subtitle1">Role</Typography>
              <Autocomplete
                disabled
                disablePortal
                fullWidth
                name=""
                value={currentUser?.user_role || null}
                options={USER_ROLE_LIST}
                getOptionLabel={(option) => (option ? option.access_profile_name : '')}
                renderInput={(params) => <TextField {...params} label="" margin="none" />}
              />
            </Stack>
            <ChangePassword />
          </Stack>
        </Card>
      </Grid>
    </Grid>
  );
}
